import React from 'react';
import { authenticationService } from 'auth/authenticationService.js'

import {
  Box,
  Typography,
  Button,
  Alert,
  Chip,
  CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Table, TableHead, TableBody, TableRow, TableCell, TableContainer,
} from '@mui/material';

import NumberFormat from 'react-number-format';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

// Botón "Ver Pago": muestra en un modal las cuotas del permiso según SMC (sólo lectura)
class DetallePago extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      loading: false,
      error: null,
      data: null,
      ver_otros_agnos: false,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({ open: true, loading: true, error: null, data: null, ver_otros_agnos: false });

    authenticationService.fetchApi({
      url: '/permisos/detalle_pago/' + this.props.permiso_uuid,
      method: 'GET',
      no_error_popup: true
    })
      .then(result => {
        this.setState({ data: result, loading: false });
      })
      .catch(err => {
        this.setState({
          loading: false,
          error: err && err.error === 'SMC_NO_DISPONIBLE' ?
            'No fue posible consultar SMC en este momento. Intenta nuevamente en unos minutos.' :
            'No fue posible obtener la información del pago.'
        });
      });
  }

  handleClose() {
    this.setState({ open: false });
  }

  formatFecha(fecha) {
    if (!fecha) {
      return '-';
    }
    const [agno, mes, dia] = fecha.split('-');
    return dia + '-' + mes + '-' + agno;
  }

  monto(valor) {
    if (valor === null || valor === undefined) {
      return '-';
    }
    return <NumberFormat displayType={'text'} value={valor} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} />;
  }

  tablaCuotas(cuotas, mostrarAgno = false) {
    return (
      <TableContainer>
        <Table size='small'>
          <TableHead>
            <TableRow>
              {mostrarAgno && <TableCell>Año</TableCell>}
              <TableCell>Cuota</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Fecha emisión</TableCell>
              <TableCell>Fecha pago</TableCell>
              <TableCell>Folio</TableCell>
              <TableCell align='right'>Valor permiso</TableCell>
              <TableCell align='right'>Reajuste + interés</TableCell>
              <TableCell align='right'>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cuotas.map(cuota => (
              <TableRow key={cuota.estado + '_' + cuota.folio + '_' + cuota.cod_cuota}>
                {mostrarAgno && <TableCell>{cuota.agno_giro}</TableCell>}
                <TableCell>{cuota.cuota}</TableCell>
                <TableCell>
                  <Chip size='small'
                    label={cuota.estado}
                    color={cuota.estado === 'Pagada' ? 'success' : 'warning'}
                  />
                </TableCell>
                <TableCell>{this.formatFecha(cuota.fecha_emision)}</TableCell>
                <TableCell>{this.formatFecha(cuota.fecha_pago)}</TableCell>
                <TableCell>{cuota.folio ? cuota.folio : '-'}</TableCell>
                <TableCell align='right'>{this.monto(cuota.valor_permiso)}</TableCell>
                <TableCell align='right'>
                  {cuota.estado === 'Pendiente' ? this.monto((cuota.reajuste || 0) + (cuota.interes || 0)) : '-'}
                </TableCell>
                <TableCell align='right'><strong>{this.monto(cuota.total)}</strong></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  render() {
    const data = this.state.data;
    return (
      <>
        <Button onClick={this.handleOpen}
          variant='contained'
          color='primary'
          startIcon={<ReceiptLongIcon />}
        >
          Ver Pago
        </Button>

        <Dialog open={this.state.open} onClose={this.handleClose} maxWidth='lg' fullWidth>
          <DialogTitle>
            Información del pago {data ? '- ' + data.patente + ' (proceso ' + data.agno_proceso + ')' : ''}
          </DialogTitle>
          <DialogContent dividers>
            {this.state.loading &&
              <Box p={3} textAlign='center'>
                <CircularProgress />
                <Box>
                  <Typography variant='caption'>Consultando SMC...</Typography>
                </Box>
              </Box>
            }

            {this.state.error &&
              <Alert severity='error'>{this.state.error}</Alert>
            }

            {data &&
              <Box>
                <Box pb={2}>
                  <Box>
                    <Typography variant='caption'>Estado del permiso</Typography>
                    <Typography variant='caption' sx={{ fontWeight: 'bold' }}>: {data.estado}</Typography>
                  </Box>
                  {data.contribuyente_smc &&
                    <Box>
                      <Typography variant='caption'>Contribuyente en SMC</Typography>
                      <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
                        : {data.contribuyente_smc.nombre} {data.contribuyente_smc.rut ? '(' + data.contribuyente_smc.rut + ')' : ''}
                      </Typography>
                    </Box>
                  }
                  {data.tasacion &&
                    <Box>
                      <Typography variant='caption'>Tasación</Typography>
                      <Typography variant='caption' sx={{ fontWeight: 'bold' }}>: {this.monto(data.tasacion)}</Typography>
                    </Box>
                  }
                </Box>

                <Typography variant='h6'>Cuotas del proceso {data.agno_proceso}</Typography>
                {data.cuotas.length > 0 ?
                  this.tablaCuotas(data.cuotas) :
                  <Alert severity='info'>No hay pagos ni cuotas pendientes en SMC para el proceso {data.agno_proceso}.</Alert>
                }

                <Box pt={2}>
                  <Typography variant='body2'>
                    Total pagado: <strong>{this.monto(data.total_pagado)}</strong>
                  </Typography>
                  <Typography variant='body2'>
                    Total pendiente: <strong>{this.monto(data.total_pendiente)}</strong>
                  </Typography>
                </Box>

                {data.deuda_otros_agnos > 0 &&
                  <Box pt={2}>
                    <Alert severity='warning'>
                      Este vehículo tiene deuda pendiente de otros años por {this.monto(data.deuda_otros_agnos)}.
                    </Alert>
                  </Box>
                }

                {data.otros_agnos.length > 0 &&
                  <Box pt={2}>
                    <Button size='small' onClick={() => this.setState(prevState => ({ ver_otros_agnos: !prevState.ver_otros_agnos }))}>
                      {this.state.ver_otros_agnos ? 'Ocultar otros años' : 'Ver otros años (' + data.otros_agnos.length + ')'}
                    </Button>
                    {this.state.ver_otros_agnos && this.tablaCuotas(data.otros_agnos, true)}
                  </Box>
                }

                <Box pt={2}>
                  <Typography variant='caption' color='textSecondary'>
                    Información consultada en línea a SMC. Esta consulta no modifica el estado del permiso
                    (para actualizarlo usa "Consultar Pago en SMC").
                  </Typography>
                </Box>
              </Box>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default DetallePago;
